/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest } from 'redux-saga/effects';

import * as commonSagas from '../_common/commonSagas';
import * as auditSlice from './auditSlice';

export default function* watchAuditSaga() {
	yield takeLatest(auditSlice.getTableStart.type, commonSagas.getTable);
	yield takeLatest(auditSlice.getItemStart.type, commonSagas.getItem);
	yield takeLatest(auditSlice.createItemStart.type, commonSagas.createItem);
	yield takeLatest(auditSlice.updateItemStart.type, commonSagas.updateItem);
	yield takeLatest(auditSlice.deleteItemsStart.type, commonSagas.deleteItems);
	yield takeLatest(auditSlice.deleteItemStart.type, commonSagas.deleteItem);
	yield takeLatest(
		auditSlice.getTableStructureStart.type,
		commonSagas.getTableStructure,
	);
	yield takeLatest(
		auditSlice.getItemDocumentsStart.type,
		commonSagas.getItemDocuments,
	);
	yield takeLatest(
		auditSlice.uploadItemDocumentsStart.type,
		commonSagas.uploadItemDocuments,
	);
	yield takeLatest(
		auditSlice.deleteItemDocumentStart.type,
		commonSagas.deleteItemDocument,
	);
	yield takeLatest(
		auditSlice.getTableExcelStart.type,
		commonSagas.getTableExcel,
	);
}
